<template>
  <div>
    <header class="text-center pb-4">
      <h3
        class="my-0 text-2xl font-bold"
        v-text="union.name"
      />
    </header>

    <PaymentForm
      :run-confirm-card-setup="runPaymentSetup"
      @cardSetupConfirmed="handleCardSetupConfirmed"
      @cardSetupError="handleCardSetupError"
      @loaded="loaded = true"
      title="Your payment is not current"
      description="Please update your credit card information to access your dashboard."
    />
    <div
      v-if="loaded"
      class="modal-footer text-center mt-8"
    >
      <button
        type="button"
        :class="{ 'load': processing }"
        :disabled="processing"
        :aria-disabled="processing"
        class="btn"
        @click="setupPayment"
        v-text="'Submit Payment'"
      />
    </div>

  </div>
</template>

<script type="text/babel">
import PaymentForm from 'Payments/Resources/assets/js/components/MembershipFeePaymentForm'

export default {
  name: 'BlockingPaymentForm',
  components: {
    PaymentForm,
  },
  props: {
    union: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loaded: false,
    processing: false,
    runPaymentSetup: false,
  }),
  methods: {
    setupPayment() {
      this.processing = true
      this.runPaymentSetup = true
    },
    handleCardSetupConfirmed({ setupIntent }) {
      this.$api.active().post('payments/membership-fee/submit', { setup_intent: setupIntent })
        .then(() => window.location = `${this.$urlGenerator.active()}dashboard`)
        .finally(() => this.processing = false)
    },
    handleCardSetupError() {
      this.processing = false
      this.runPaymentSetup = false
    },
  },
}
</script>
